import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH. The redirect URI was persisted to sessionStorage
// during startGoogleLogin() — AuthContext.finishGoogleLogin reads it back.
export default function GoogleCallback() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { finishGoogleLogin } = useAuth();
    const [error, setError] = useState("");
    const ran = useRef(false); // React 18 StrictMode fires effects twice — guard.

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;

        const code = params.get("code");
        const state = params.get("state");
        const err = params.get("error");
        if (err) {
            setError(`Google returned: ${err}`);
            return;
        }
        if (!code || !state) {
            setError("Missing code/state from Google — please try again.");
            return;
        }
        finishGoogleLogin(code, state)
            .then(() => navigate("/terminal", { replace: true }))
            .catch((e) => setError(e.message));
    }, [params, finishGoogleLogin, navigate]);

    return (
        <div className="min-h-[calc(100vh-3.5rem)] bg-[#050505] grid place-items-center px-4">
            <div className="w-full max-w-md bg-[#0A0A0C] border border-[#1F1F24] p-8 rounded-sm">
                <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-cyan-400 mb-3">
                    Google · Sign in
                </div>
                {error ? (
                    <>
                        <h1 className="text-xl font-medium tracking-tight text-rose-300" data-testid="google-callback-error">
                            Sign-in failed
                        </h1>
                        <p className="mt-3 text-sm text-zinc-400 font-mono">{error}</p>
                        <button
                            data-testid="google-callback-retry"
                            onClick={() => navigate("/auth", { replace: true })}
                            className="mt-6 bg-cyan-400 hover:bg-cyan-300 text-black font-semibold px-4 py-2 rounded-sm text-sm"
                        >
                            Back to sign in →
                        </button>
                    </>
                ) : (
                    <>
                        <h1 className="text-xl font-medium tracking-tight">Finishing your Google sign-in…</h1>
                        <p className="mt-3 text-sm text-zinc-500 font-mono">
                            Verifying with Google and provisioning your wallet.
                        </p>
                        <div className="mt-6 h-1 w-full bg-[#1F1F24] overflow-hidden">
                            <div className="h-full w-1/3 bg-cyan-400 animate-pulse" />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
